import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  FiEdit3,
  FiTrash2,
  FiBriefcase,
  FiArrowLeft,
  FiRefreshCw,
  FiInfo,
  FiX,
  FiAlertCircle,
  FiActivity, FiPlus
} from "react-icons/fi";
import {
  fetchDesignations,
  deleteDesignation,
  updateDesignation,
} from "../../redux/actions/designationActions";
import { useNavigate } from "react-router-dom";

const Designations = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { designations, loading, error } = useSelector(
    (state) => state.designation
  );

  const [editItem, setEditItem] = useState(null);
  const [editName, setEditName] = useState("");
  const [editStatus, setEditStatus] = useState(1);

  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [deleteItem, setDeleteItem] = useState(null);

  useEffect(() => {
    dispatch(fetchDesignations());
  }, [dispatch]);

  const startEdit = (item) => {
    setEditItem(item);
    setEditName(item.name);
    setEditStatus(item.status ?? 1); // I have set default to 1 (Active)
  };

  const saveEdit = async () => {
    await dispatch(
      updateDesignation(editItem.id, {
        name: editName,
        status: editStatus,
      })
    );

    setEditItem(null);
    setEditName("");
    setEditStatus(1);
  };

  const openDeleteModal = (item) => {
    setDeleteItem(item);
    setConfirmDeleteOpen(true);
  };

  const closeDeleteModal = () => {
    setDeleteItem(null);
    setConfirmDeleteOpen(false);
  };

  const confirmDelete = () => {
    dispatch(deleteDesignation(deleteItem.id));
    closeDeleteModal();
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 p-6 flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-cyan-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600 dark:text-gray-400 text-lg">
            Loading Designations...
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-8 px-4">
      <div className="max-w-6xl mx-auto">
<div className="flex items-center justify-between mb-8">
  {/* Left */}
  <button
    onClick={() => navigate("/dashboard")}
    className="flex items-center gap-2 text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white transition-colors p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800"
  >
    <FiArrowLeft className="text-lg" />
    Back to Dashboard
  </button>

  {/* Right */}
  <div className="flex items-center gap-3">
    <button
      onClick={() => navigate("/dashboard/create-Designation")}
      className="flex items-center gap-2 bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 rounded-xl transition-all shadow-md"
    >
      <FiPlus className="text-lg" />
      Create Designation
    </button>

    <button
      onClick={() => dispatch(fetchDesignations())}
      className="flex items-center gap-2 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-200 py-2 px-4 rounded-xl border border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors shadow-sm"
    >
      <FiRefreshCw className="text-lg" />
      Refresh
    </button>
  </div>
</div>


        <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg border border-gray-200 dark:border-gray-700 overflow-hidden">
          <div className="bg-gradient-to-r from-cyan-600 to-blue-600 px-6 py-8">
            <div className="flex items-center gap-4">
              <div className="p-3 bg-white/20 rounded-xl">
                <FiBriefcase className="text-2xl text-white" />
              </div>
              <div>
                <h1 className="text-2xl font-bold text-white mb-2">
                  Designations
                </h1>
                <p className="text-cyan-100">
                  Manage job titles and their active availability
                </p>
              </div>
            </div>
          </div>

          <div className="p-6">
            {error && (
              <div className="mb-6 p-4 bg-red-50 dark:bg-red-900/30 border border-red-200 dark:border-red-800 rounded-xl">
                <div className="flex items-center gap-3">
                  <FiAlertCircle className="text-red-500" />
                  <p className="text-red-800 dark:text-red-300 font-medium">
                    {error}
                  </p>
                </div>
              </div>
            )}

            {/* Table Area */}
            <div className="bg-gray-50 dark:bg-gray-900/40 rounded-xl border border-gray-200 dark:border-gray-700 overflow-hidden">
              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead>
                    <tr className="bg-gray-100 dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
                      <th className="py-4 px-6 text-left text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-widest">
                        #
                      </th>
                      <th className="py-4 px-6 text-left text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-widest">
                        Designation Name
                      </th>
                      <th className="py-4 px-6 text-left text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-widest">
                        Status
                      </th>
                      <th className="py-4 px-6 text-right text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-widest">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
                    {designations.length > 0 ? (
                      designations.map((d, index) => (
                        <tr
                          key={d.id}
                          className="group hover:bg-white dark:hover:bg-gray-800 transition-all"
                        >
                          <td className="py-4 px-6 text-sm text-gray-500 font-mono">
                            {String(index + 1).padStart(2, "0")}
                          </td>
                          <td className="py-4 px-6">
                            <span className="text-sm font-semibold text-gray-900 dark:text-white group-hover:text-cyan-600 dark:group-hover:text-cyan-400 transition-colors">
                              {d.name}
                            </span>
                          </td>
                          <td className="py-4 px-6">
                            <span
                              className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-bold ${
                                d.status === 1
                                  ? "bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400"
                                  : "bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400"
                              }`}
                            >
                              <span
                                className={`w-1.5 h-1.5 rounded-full ${
                                  d.status === 1 ? "bg-green-500" : "bg-red-500"
                                }`}
                              ></span>
                              {d.status === 1 ? "Active" : "Inactive"}
                            </span>
                          </td>
                          <td className="py-4 px-6">
                            <div className="flex justify-end gap-2">
                              <button
                                onClick={() => startEdit(d)}
                                className="p-2 bg-blue-50 dark:bg-blue-900/20 text-blue-600 dark:text-blue-400 rounded-lg hover:bg-blue-600 dark:hover:bg-blue-600 dark:hover:text-white hover:text-white transition-all shadow-sm"
                              >
                                <FiEdit3 size={16} />
                              </button>
                              <button
                                onClick={() => openDeleteModal(d)}
                                className="p-2 bg-red-50 dark:bg-red-900/20 text-red-600 dark:text-red-400 rounded-lg hover:bg-red-600 dark:hover:bg-red-600 dark:hover:text-white hover:text-white transition-all shadow-sm"
                              >
                                <FiTrash2 size={16} />
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan="4"
                          className="py-12 text-center text-gray-500"
                        >
                          No designations found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      {editItem && (
        <div className="fixed inset-0 bg-gray-900/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-white dark:bg-gray-800 rounded-3xl max-w-md w-full shadow-2xl overflow-hidden">
            <div className="bg-gradient-to-r from-blue-600 to-cyan-600 px-6 py-4 flex justify-between items-center">
              <h3 className="text-lg font-bold text-white flex items-center gap-2">
                <FiEdit3 /> Edit Designation
              </h3>
              <button
                onClick={() => setEditItem(null)}
                className="text-white/80 hover:text-white"
              >
                <FiX size={20} />
              </button>
            </div>
            <div className="p-6 space-y-6">
              <div>
                <label className="block text-xs font-bold text-gray-400 uppercase tracking-widest mb-2">
                  Designation Name
                </label>
                <input
                  type="text"
                  value={editName}
                  onChange={(e) => setEditName(e.target.value)}
                  className="w-full px-4 py-3 rounded-xl border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 outline-none transition-all"
                  placeholder="Designation name"
                />
              </div>

              <div>
                <label className="block text-xs font-bold text-gray-400 uppercase tracking-widest mb-2 flex items-center gap-2">
                  <FiActivity /> Availability Status
                </label>
                <div className="flex gap-3">
                  <button
                    type="button"
                    onClick={() => setEditStatus(1)}
                    className={`flex-1 p-3 rounded-xl border-2 font-bold transition-all ${
                      editStatus === 1
                        ? "border-green-500 bg-green-50 dark:bg-green-900/20 text-green-700 dark:text-green-300"
                        : "border-gray-100 dark:border-gray-700 bg-gray-50 dark:bg-gray-900 text-gray-400"
                    }`}
                  >
                    Active
                  </button>
                  <button
                    type="button"
                    onClick={() => setEditStatus(0)}
                    className={`flex-1 p-3 rounded-xl border-2 font-bold transition-all ${
                      editStatus === 0
                        ? "border-red-500 bg-red-50 dark:bg-red-900/20 text-red-700 dark:text-red-300"
                        : "border-gray-100 dark:border-gray-700 bg-gray-50 dark:bg-gray-900 text-gray-400"
                    }`}
                  >
                    Inactive
                  </button>
                </div>
              </div>

              <div className="flex gap-3 pt-4">
                <button
                  onClick={() => setEditItem(null)}
                  className="flex-1 bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 py-3 rounded-xl font-semibold hover:bg-gray-200 transition-all"
                >
                  Cancel
                </button>
                <button
                  onClick={saveEdit}
                  className="flex-1 bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-xl font-semibold shadow-lg shadow-blue-500/30 transition-all"
                >
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {confirmDeleteOpen && (
        <div className="fixed inset-0 bg-gray-900/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-white dark:bg-gray-800 rounded-3xl max-w-md w-full shadow-2xl overflow-hidden p-8 text-center">
            <div className="flex items-center justify-center w-16 h-16 mx-auto mb-6 bg-red-50 dark:bg-red-900/20 rounded-2xl">
              <FiTrash2 className="text-red-500 text-3xl" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2">
              Delete Designation?
            </h3>
            <p className="text-gray-500 dark:text-gray-400 mb-8">
              Are you sure you want to delete{" "}
              <span className="font-bold">"{deleteItem?.name}"</span>? This
              action cannot be undone.
            </p>
            <div className="flex gap-3">
              <button
                onClick={closeDeleteModal}
                className="flex-1 bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 py-3 rounded-xl font-semibold"
              >
                Cancel
              </button>
              <button
                onClick={confirmDelete}
                className="flex-1 bg-red-500 hover:bg-red-600 text-white py-3 rounded-xl font-semibold shadow-lg shadow-red-500/30"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Designations;
